const rootUrl = 'https://egrivel.ddns.net:4433/cgi-bin/photos/';
const batchSize = 100;
const api = {
  apiLoadData: async (cursor = '') => {
    try {
      let url = rootUrl + 'phapi?action=latest';
      url += '&count=' + batchSize;
      if (cursor !== '') {
        url += '&cursor=' + cursor;
      }
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Response status: ' + response.status);
      }
      const result = await response.json();
      const annotatedResult = result.map((item) => {
        const { imageid } = item;
        return { ...item,
          url: rootUrl + 'phimg?s150=' + imageid,
          thumbnailUrl:rootUrl + 'phimg?s150=' + imageid,
          fullUrl: rootUrl + 'phimg?edited=' + imageid
        };
      });
      return annotatedResult;
    } catch (error) {
      console.error('Got an error: ' + JSON.stringify(error));
    }
    return null;
  },
};

export default api;
